import {
  StoryClusterPage as StoryClusterPageBase,
  StoryClusterPageMeta,
} from '@aboutyou/logic-components';
import React from 'react';
import {StoryPage} from '../../../../bridge/pages/StoryPage';

export const StoryClusterPage = () => {
  const preloadOutfitDetailPage = () => {
    StoryPage.preload();
  };

  return (
    <>
      <StoryClusterPageMeta />
      <StoryClusterPageBase preloadOutfitDetailPage={preloadOutfitDetailPage} />
    </>
  );
};
